import { useState, ComponentProps } from 'react'
import { useSelector } from 'react-redux'
import CenteredCustomerLoginModal from 'components/modals/getHelp/CenteredCustomerLoginModal'
import { ReactChild } from 'data/types/types'
import { RootState } from 'store'
import PublicMobileModal, { PublicMobileModalProps } from './PublicMobileModal'
import { FieldValues, UseFormHandleSubmit } from 'react-hook-form'
import SuccessModal, { SuccessModalProps } from './modals/home/SuccessModal'
import classNames from 'classnames'

interface PublicMobileModalFormWithAuthProps<T extends FieldValues> extends PublicMobileModalProps {
  children: ReactChild
  handleSubmit: UseFormHandleSubmit<T>
  formProps: Omit<ComponentProps<'form'>, 'onSubmit'> & {
    onSubmit: (details: T) => void
  }
  loginModal: {
    onSubmit: () => void
  }
  successModal?: SuccessModalProps
}

export default function PublicMobileModalFormWithAuth<T extends FieldValues> ({
  children,
  handleSubmit,
  formProps,
  loginModal,
  successModal,
  ...props
}: PublicMobileModalFormWithAuthProps<T>) {
  const user = useSelector((state: RootState) => state.auth.user)

  const [loginModalOpen, setLoginModalOpen] = useState(false)

  const onSubmit = (details: T) => {
    if (user) {
      formProps.onSubmit(details)
    } else {
      setLoginModalOpen(true)
    }
  }

  return (
    <PublicMobileModal {...props}>
      <form
        {...formProps}
        onSubmit={handleSubmit(onSubmit)}
        className={classNames(
          formProps.className,
          {
            'hidden': loginModalOpen || successModal?.isOpen,
          },
        )}
      >
        {children}
      </form>

      <CenteredCustomerLoginModal
        isOpen={loginModalOpen}
        onClose={(user) => {
          setLoginModalOpen(false)
          if (user) {
            loginModal.onSubmit()
          }
        }}
      />

      {
        successModal && (
          <SuccessModal
            {...successModal}
            button={{
              ...successModal.button,
              onClick: (e) => {
                successModal.button?.onClick?.(e)
                props.onClose()
              },
              style: 'modal',
            }}
            className={props.className}
          />
        )
      }
    </PublicMobileModal>
  )
}
